export interface LifeEventDefinition {
  label: string;
  goodHouses: number[];
  badHouses: number[];
  goodSupportiveHouses: number[];
  badSupportiveHouses: number[];
}

export const FREE_LIFE_EVENT_KEYS = new Set(['none', 'education', 'awards', 'prize', 'career']);

const createEvent = (
  label: string,
  goodHouses: number[] = [],
  badHouses: number[] = [],
  goodSupportiveHouses: number[] = [],
  badSupportiveHouses: number[] = []
): LifeEventDefinition => ({
  label,
  goodHouses,
  badHouses,
  goodSupportiveHouses,
  badSupportiveHouses
});

export const lifeEvents: Record<string, LifeEventDefinition> = {
  none: createEvent('None'),
  education: createEvent('Education', [2, 4, 5, 9, 11], [6, 8, 12], [3], [3]),
  awards: createEvent('Awards', [10, 11], [6, 8, 12], [5, 9]),
  prize: createEvent('Prize', [6, 11], [6, 8, 12], [5, 9]),
  career: createEvent('Career', [2, 6, 7, 10, 11], [6, 8, 12], [5, 9]),
  love: createEvent('Love', [5, 8, 11, 12], [], [6]),
  marriage: createEvent('Marriage', [2, 7, 11], [1, 6, 10], [5, 9], [6, 8, 12]),
  dowry_legacy: createEvent('Dowry or Legacy', [8, 11], [], [10]),
  divorce: createEvent('Divorce', [2, 5, 7, 9, 11], [1, 6, 8, 10, 12]),
  abortion: createEvent('Abortion', [2, 5, 9, 11], [1, 4, 6, 8, 12]),
  child_birth: createEvent('Child Birth', [2, 5, 11], [1, 4, 10], [9], [6, 8, 12]),
  property_vehicle_purchase: createEvent('Property/Vehicle Purchase', [4, 11, 12], [], [], [6, 8]),
  property_vehicle_sale: createEvent('Property/Vehicle Sale', [3, 5, 10], [], [], [6, 8, 12]),
  love_caring: createEvent('Love and Caring', [2, 5, 9, 11], [1, 4, 6, 10]),
  depression: createEvent('Depression', [], [1, 2, 6, 8]),
  aggression: createEvent('Aggression', [], [7, 8, 12]),
  health: createEvent('Health', [5, 9, 11], [1, 4, 6, 8, 10, 12]),
  travel: createEvent('Travel', [3, 9, 12]),
  homecoming: createEvent('Homecoming', [2, 4, 11]),
  litigation: createEvent('Litigation', [6, 10, 11], [6, 8, 12], [5, 9]),
  arrest: createEvent('Arrest', [], [2, 3, 8, 12])
};
